import { CollapsibleTrigger as Trigger } from '@radix-ui/react-collapsible'

export const CollapsibleTrigger = Trigger
